import { Expandable } from '@/components/global'
import Flex from '@/components/priority/Flex/Flex'
import CaseFormSection from '../CaseFormSection'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIsM3Order } from '@/hooks/utility/useIsM3Order'

type CasePreferencesProps = {
  saveCase: () => void
}

export const CasePreferences = ({ saveCase }: CasePreferencesProps) => {
  const { t } = useTranslation()
  const [expandedHeaders, setExpandedHeaders] = useState<boolean>(true)
  const isM3Order = useIsM3Order()

  const saveAndContinue = () => {
    setExpandedHeaders(false)
    saveCase()
  }

  return (
    <Flex column full padding="0 48px 0 0">
      <Flex column align="flex-start">
        <Expandable
          margin="0 0 32px 0"
          title={t('caseDetails.tabs.casePreferences.headers')}
          show={[expandedHeaders, setExpandedHeaders]}
          full
        >
          <CaseFormSection
            formSection="headers"
            saveAndContinue={saveAndContinue}
            isM3Order={isM3Order}
          />
        </Expandable>
      </Flex>
    </Flex>
  )
}

export default CasePreferences
